import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobPlantComponent } from './jobPlant.component';
// import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgbModule, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';

import { BrowserModule } from '@angular/platform-browser';
import { DataTablesModule } from 'angular-datatables';


@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    // NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,

    BrowserModule,
    DataTablesModule
  ],
  declarations: [JobPlantComponent]
})
export class JobPlantModule { }
